import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, Mail, ReceiptText, ArrowDownRight, ArrowUpRight } from 'lucide-react';
import PageHeading from '../components/PageHeading';

export function ContactCards() {
  return (
    <div className="grid md:grid-cols-2 gap-5">
      <article className="page-card">
        <span className="page-icon mb-5"><MessageCircle aria-hidden="true" /></span>
        <h2 className="text-xl font-bold mb-3">右下角，找到大师兄</h2>
        <p className="text-sm text-muted mb-5">AI 订阅、广告代充、订单查询或售后问题，点击右下角客服气泡，与真人客服沟通。</p>
        <div className="flex items-center gap-2 text-sm text-brand"><span className="w-2 h-2 rounded-full bg-brand" />服务时间 · 9:00—23:00<ArrowDownRight size={18} aria-hidden="true" /></div>
      </article>
      <article className="page-card">
        <span className="page-icon mb-5"><Mail aria-hidden="true" /></span>
        <h2 className="text-xl font-bold mb-3">邮件联系</h2>
        <p className="text-sm text-muted mb-5">适合非紧急问题，平均 2–3 天回复。订单问题请附上订单号，便于客服核对。</p>
        <a href="mailto:ricky@savvyai.plus" className="inline-flex items-center gap-2 text-sm font-semibold text-brand break-all">ricky@savvyai.plus<ArrowUpRight size={16} aria-hidden="true" /></a>
      </article>
    </div>
  );
}

export default function CustomerService() {
  return (
    <div className="page-shell">
      <PageHeading Icon={MessageCircle} eyebrow="SUPPORT · 真人客服" title="有问题，找大师兄" description="从 AI 到广告，代充咨询与订单售后都在这里。" />
      <ContactCards />
      <div className="page-card mt-5 flex flex-wrap items-center gap-5 bg-brand-soft">
        <ReceiptText className="text-brand" size={32} aria-hidden="true" />
        <div className="flex-1 min-w-[200px]"><h2 className="font-bold mb-1">需要 Invoice？免费领取</h2><p className="text-sm text-muted">联系右下角客服，提供订单号即可申请。</p></div>
        <Link to="/after-sales/invoice" className="page-secondary">查看领取说明<ArrowUpRight size={16} aria-hidden="true" /></Link>
      </div>
      <div className="flex flex-wrap gap-4 mt-7 text-sm text-muted"><Link to="/orders" className="hover:text-brand">查看历史订单 ↗</Link><Link to="/upgrade-guide" className="hover:text-brand">升级与使用教程 ↗</Link></div>
    </div>
  );
}
